import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/qcTask';

import { actions } from './QCTaskSeries.slice';
import { QCTaskSeriesFetchAction } from './QCTaskSeries.types';
import { Resp, dispatch } from '../helpers';
import { transformSeries } from './QCTaskSeries.helpers';

export function* fetchQCTaskSeriesWorker(action: QCTaskSeriesFetchAction) {
  try {
    const response: Resp<typeof api.fetchQCTaskSeries> = yield call(
      api.fetchQCTaskSeries,
      action.payload.clinicalTrialId,
      action.payload.taskId
    );

    const series = response.data.visits || [];
    const {
      assignedLabelsByVisit,
      flatSeries,
      flatVisits,
    }: ReturnType<typeof transformSeries> = yield call(transformSeries, series);

    yield dispatch(actions.setAssignedLabelsByVisit(assignedLabelsByVisit));
    yield dispatch(actions.setFlatSeries(flatSeries));
    yield dispatch(actions.setFlatVisits(flatVisits));
    yield dispatch(actions.fetchQCTaskSeriesSuccess(series));
  } catch (error) {
    yield dispatch(actions.fetchQCTaskSeriesFailure(error as Error));
  }
}

export function* QCTaskSeriesSaga() {
  yield takeLatest(actions.fetchQCTaskSeries.type, fetchQCTaskSeriesWorker);
}
